<template>
    <teleport to="body">
        <div class="toast-wrap">
            <transition-group name="toast">
                <div v-for="t in toasts" :key="t.id" class="toast card neon" :class="t.type">
                    <span class="toast-bar"></span>
                    <span class="toast-icon">{{ iconOf(t.type) }}</span>
                    <div class="toast-body">
                        <div class="t-title">{{ t.title }}</div>
                        <div v-if="t.message" class="t-msg muted">{{ t.message }}</div>
                    </div>
                </div>
            </transition-group>
        </div>
    </teleport>
</template>

<script>
export default {
    name: "ToastHost",
    data() {
        return { toasts: [] };
    },
    methods: {
        push(opts) {
            const title = opts.title || "OK";
            const message = opts.message || "";
            const type = opts.type || "ok";
            const ms = opts.ms || 2600;
            const id = Math.random().toString(16).slice(2);
            this.toasts.push({ id, title, message, type });
            setTimeout(() => {
                this.toasts = this.toasts.filter((x) => x.id !== id);
            }, ms);
        },
        iconOf(type) {
            if (type === "ok") return "OK";
            if (type === "warn") return "!";
            if (type === "bad") return "X";
            return "i";
        },
    },
};
</script>

<style scoped>
.toast-wrap {
    position: fixed;
    top: 18px;
    right: 18px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    z-index: 99999;
    max-width: calc(100vw - 36px);
}

.toast {
    position: relative;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    width: 340px;
    max-width: 100%;
    padding: 13px 15px 13px 18px;
    border-radius: var(--r-md);
    overflow: hidden;
}

.toast-bar {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
}

.toast-icon {
    flex: 0 0 auto;
    width: 28px;
    height: 26px;
    border-radius: 8px;
    display: grid;
    place-items: center;
    font-weight: 800;
    font-size: 12px;
}

.toast-body {
    min-width: 0;
}

.t-title {
    font-weight: 700;
    letter-spacing: .01em;
}

.t-msg {
    margin-top: 3px;
    font-size: 12.5px;
    word-break: break-all;
}

.ok {
    border-color: rgba(0, 255, 168, .3);
}

.ok .toast-bar {
    background: var(--c-mint);
}

.ok .toast-icon {
    background: rgba(0, 255, 168, .16);
    color: #b6ffe5;
}

.warn {
    border-color: rgba(255, 176, 32, .3);
}

.warn .toast-bar {
    background: var(--c-amber);
}

.warn .toast-icon {
    background: rgba(255, 176, 32, .16);
    color: #ffe0a6;
}

.bad {
    border-color: rgba(255, 77, 141, .35);
}

.bad .toast-bar {
    background: var(--c-pink);
}

.bad .toast-icon {
    background: rgba(255, 77, 141, .16);
    color: #ffc2d6;
}

.toast-enter-active,
.toast-leave-active {
    transition: all .26s cubic-bezier(.22, 1, .36, 1);
}

.toast-enter-from {
    transform: translateX(40px);
    opacity: 0;
}

.toast-leave-to {
    transform: translateX(40px);
    opacity: 0;
}

@media (max-width: 768px) {
    .toast-wrap {
        left: 12px;
        right: 12px;
        top: 12px;
    }

    .toast {
        width: 100%;
    }
}
</style>
